import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GlobalStateProvider } from "./Stores";

import App from "./App";
import Footer from "./Footer";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <GlobalStateProvider>
      <App />
      <Footer />
    </GlobalStateProvider>
  </StrictMode>
);
